import {
  Button,
  Chip,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Typography,
  withStyles,
  Container,
  FormControl,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Select,
  MenuItem,
  FormGroup,
  FormControlLabel,
  Checkbox,
  IconButton,
  CircularProgress,
  Box
} from '@material-ui/core';
import {
  Add,
  Delete as DeleteIcon,
  Info as InfoIcon,
  ArrowBack as ArrowBackIcon,
  Save as SaveIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon
} from '@material-ui/icons';
import { Autocomplete } from '@material-ui/lab';
import MuiAlert, { AlertProps, type Color } from '@material-ui/lab/Alert';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@services/api';
import { estados } from '@data/estados';
import { planos } from '@data/planos';
import { makeStyles } from '@material-ui/core/styles';

import { useTheme } from '@material-ui/core/styles';

interface IExames {
  id_exames: string;
  nome: string;
  dias: string;
  admissional?: string;
  demissional?: string;
  periodico?: string;
  mudancaRiscos?: string;
  retornoAoTrabalho?: string;
  monitoramento?: string;
}

interface IRiscos {
  id_risco: string;
  nome: string;
}

interface ICnpj {
  bairro: string;
  cep: string;
  cidade: string;
  cnae: string;
  cnae_secundario: string;
  complemento: string;
  estado: string;
  idcad_empresa: number;
  inf_contrato: string;
  nome_empresa: string;
  nome_fantacia: string;
  num_cnpj: string;
  numero: number | null;
  razao_social: string;
  rua: string;
}

export interface IRiscosEdit extends IRiscos {
  id_risco_ghe?: number;
  cod_ghe?: string;
  id_risco: string;
  nome: string;
}

interface IExamesToxico {
  id_exame_tox: string;
  nome: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: '#f9f9f9'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f9f9f9',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999
  },
  loadingContent: {
    textAlign: 'center',
    padding: theme.spacing(4),
    borderRadius: theme.spacing(1),
    backgroundColor: '#fff',
    boxShadow: theme.shadows[4]
  },
  loadingText: {
    marginTop: theme.spacing(2),
    color: '#0D9C5B',
    fontWeight: 500
  },
  highlight: {
    borderLeft: '4px solid #0D9C5B',
    backgroundColor: '#f0f7f4',
    transition: 'all 0.3s ease',
    transform: 'scale(1.02)',
    boxShadow: '0 4px 20px 0 rgba(13, 156, 91, 0.2)'
  },
  loadingPaper: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#f9f9f9'
  }
}));

const ButtonAdd = withStyles(() => ({
  root: {
    background: '#0D9C5B',
    color: '#FFF',
    border: 'none',
    borderRadius: '8px',
    fontWeight: 500,
    padding: '8px 16px',
    textTransform: 'none',
    '&:hover': {
      background: '#FFF',
      borderColor: '#0D9C5B',
      color: '#0D9C5B',
      border: 'solid 1px #0D9C5B'
    }
  }
}))(Button);

export const EditGhe = (props: any) => {
  const classes = useStyles();
  const [codGhe, setCodGhe] = useState(props.location.state.cod_ghe);
  const [nomeGhe, setNomeGhe] = useState(props.location.state.nome_ghe);
  const [cnpj, setCnpj] = useState(props.location.state.cnpj);
  const [nomeMedico, setNomeMedico] = useState(props.location.state.nome_med);
  const [crm, setCrm] = useState<string>(props.location.state.crm);
  const [estadoCrm, setEstadoCrm] = useState<string>(
    props.location.state.crm_estado
  );
  const [snack, setSnack] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [cod, setCod] = useState(0);
  const [severity, setSeverity] = useState<Color>();
  // const [contratos, setContratos] = useState<ICnpj[]>([]);
  const [obsASO, setObsASO] = useState<string>(props.location.state.obs_aso);
  const [risco, setRisco] = useState<IRiscos[]>([]);
  const [listRisco, setListRisco] = useState([]);
  const [newData, setNewData] = useState<IExames[]>([]);
  const [valor, setValor] = useState<number | null>(null);
  const [novoValor, setNovoValor] = useState<any[]>([]);
  const [campoValor, setCampoValor] = useState<any[]>([]);
  const [dialog, setDialog] = useState<boolean>(false);
  const [singleExame, setSingleExame] = useState<IExames | null>(null);
  const [valorTotal, setValorTotal] = useState<number>(0);
  const [plano, setPlano] = useState<string>(props.location.state.tipo_plano);
  const [valorPlano, setValorPlano] = useState<string>(
    props.location.state.valor_plano
  );
  const [asoCheck, setAsoCheck] = useState({
    admissional: false,
    demissional: false,
    periodico: false,
    mudancaDeRiscos: false,
    retornoAoTrabalho: false,
    monitoramento: false
  });
  const [valorToxico, setValorToxico] = useState<number | null>(null);
  const [novoValorToxico, setNovoValorToxico] = useState<any[]>([]);
  const [campoValorToxico, setCampoValorToxico] = useState<any[]>([]);
  const [dialogToxico, setDialogToxico] = useState<boolean>(false);
  const [singleExameToxico, setSingleExameToxico] =
    useState<IExamesToxico | null>(null);
  const [valorTotalToxico, setValorTotalToxico] = useState<number>(0);
  const [newDataToxico, setNewDataToxico] = useState<IExamesToxico[]>([]);

  const [loading, setLoading] = useState({
    inicial: true,
    enviando: false
  });
  const [dadosCarregados, setDadosCarregados] = useState(false);
  const [ultimoExameAdicionado, setUltimoExameAdicionado] = useState<
    string | null
  >(null);
  const [ultimoExameToxicoAdicionado, setUltimoExameToxicoAdicionado] =
    useState<string | null>(null);

  const [examesDestacados, setExamesDestacados] = useState<string[]>([]); // Para exames comuns
  const [examesToxicosDestacados, setExamesToxicosDestacados] = useState<
    string[]
  >([]); // Para exames toxicológicos

  const [riscosDestacados, setRiscosDestacados] = useState<string[]>([]);

  const theme = useTheme();

  useEffect(() => {
    const fetchDataSequentially = async () => {
      try {
        setLoading({ inicial: true, enviando: false });
        setDadosCarregados(false);

        const examesRes = await api.get('/ravim/exames');
        setNewData(examesRes.data);

        const riscosRes = await api.get('ravim/riscos');
        setListRisco(riscosRes.data);

        const toxicologicoRes = await api.get('ravim/exame-tox');
        setNewDataToxico(toxicologicoRes.data);

        // const contratosRes = await api.get('ravim/empresas-rh');
        // setContratos(contratosRes.data);

        await req();
        setDadosCarregados(true);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
        setSnack(true);
        setSeverity('error');
        setMessage('Erro ao carregar dados do servidor');
      } finally {
        setLoading((prev) => ({ ...prev, inicial: false }));
      }
    };

    fetchDataSequentially();
  }, []);

  useEffect(() => {
    if (ultimoExameAdicionado) {
      const timer = setTimeout(() => {
        setUltimoExameAdicionado(null);
      }, 3000000);
    }
  }, [ultimoExameAdicionado]);

  useEffect(() => {
    if (ultimoExameToxicoAdicionado) {
      const timer = setTimeout(() => {
        setUltimoExameToxicoAdicionado(null);
      }, 3000000);
    }
  }, [ultimoExameToxicoAdicionado]);

  async function req() {
    try {
      const res = await api.post(`ravim/ghe`, {
        cod_ghe: props.location.state.cod_ghe
      });

      const jsonExames = JSON.parse(res.data.exame_ghe).map((exame: any) => {
        const { id_exame_ghe, cod_ghe, ...rest } = exame;
        return rest;
      });

      const dias = jsonExames.map((dia: any) =>
        isNaN(parseFloat(dia.dias)) ? 0 : parseFloat(dia.dias)
      );
      const diasTot = dias.reduce((soma: number, i: number) => soma + i, 0);

      setCampoValor(jsonExames);
      setNovoValor(jsonExames);
      setValorTotal(diasTot);

      const jsonRiscos = JSON.parse(res.data.risco_ghe);
      setRisco(jsonRiscos);

      const jsonExamesToxi = JSON.parse(res.data.toxicologico).map(
        (exame: any) => {
          const { id_exame_ghe, cod_ghe, ...rest } = exame;
          return rest;
        }
      );

      const valorToxi = jsonExamesToxi.map((val: any) => parseFloat(val.dias));
      const valorTotToxi = valorToxi.reduce(
        (soma: number, i: number) => soma + i,
        0
      );

      setCampoValorToxico(jsonExamesToxi);
      setNovoValorToxico(jsonExamesToxi);
      setValorTotalToxico(valorTotToxi);
    } catch (err) {
      console.error('Erro ao carregar GHE:', err);
    }
  }

  async function sendGHE() {
    try {
      setLoading(prev => ({ ...prev, enviando: true }));
      
      // Garantir que todos os campos estejam no formato correto
      const examesFormatados = campoValor.map((exame) => ({
        ...exame,
        admissional: exame.admissional || '',
        demissional: exame.demissional || '',
        periodico: exame.periodico || '',
        mudanca_de_riscos: exame.mudanca_de_riscos || '',
        retorno_ao_trabalho: exame.retorno_ao_trabalho || '',
        monitoramento: exame.monitoramento || ''
      }));
  
      const toxicologicosFormatados = campoValorToxico.map((exame) => ({
        ...exame,
        admissional: exame.admissional || '',
        demissional: exame.demissional || '',
        periodico: exame.periodico || '',
        mudanca_de_riscos: exame.mudanca_de_riscos || '',
        retorno_ao_trabalho: exame.retorno_ao_trabalho || '',
        monitoramento: exame.monitoramento || ''
      }));
  
      const data = {
        cod_ghe: codGhe,
        nome_ghe: nomeGhe,
        exames_ghe: examesFormatados,
        risco_ghe: risco,
        obs_aso: obsASO,
        nome_medico: nomeMedico,
        crm,
        crm_estado: estadoCrm,
        tipo_plano: plano,
        valor_plano: valorPlano,
        toxicologico: toxicologicosFormatados
      };
  
      const res = await api.post(`ravim/update-ghe`, data);
      setSnack(true);
      setCod(res.status);
      setMessage(res.data.message);
      setSeverity('success');
      setTimeout(() => {
        window.location.replace('/ghe');
      }, 2000);
    } catch (err) {
      setSnack(true);
      setCod(500);
      setMessage('Erro ao enviar');
      setSeverity('error');
      console.error('Erro ao atualizar GHE:', err);
    } finally {
      setLoading(prev => ({ ...prev, enviando: false }));
    }
  }

  function closeDialog() {
    setDialog(false);
  }

  function saveNewValor() {
    setNovoValor([...campoValor]);
    setDialog(false);
  }

  function deleteExame(nome: string) {
    const newList = campoValor.filter((exame: any) => exame.nome !== nome);
    const verifyValues = newList.map((v: any) =>
      isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias)
    );
    const sub = verifyValues.reduce((soma: number, i: number) => soma + i, 0);

    setValorTotal(sub);
    setCampoValor(newList);
  }

  function valueExames() {
    if (!singleExame) {
      alert('Selecione um exame');
      return;
    }

    const newVar = [...campoValor];
    const data: any = {
      id_exame: singleExame.id_exames,
      nome: singleExame.nome,
      dias: valor === null ? '0' : valor.toString(),
      // Inicializa todos os campos de ASO como vazios
      admissional: '',
      demissional: '',
      periodico: '',
      mudanca_de_riscos: '',
      retorno_ao_trabalho: '',
      monitoramento: ''
    };

    // Preenche apenas os campos de ASO que foram marcados
    if (asoCheck.admissional) data.admissional = 'admissional';
    if (asoCheck.demissional) data.demissional = 'demissional';
    if (asoCheck.periodico) data.periodico = 'periodico';
    if (asoCheck.mudancaDeRiscos) data.mudanca_de_riscos = 'mudanca_de_riscos';
    if (asoCheck.retornoAoTrabalho)
      data.retorno_ao_trabalho = 'retorno_ao_trabalho';
    if (asoCheck.monitoramento) data.monitoramento = 'monitoramento';

    newVar.push(data);
    setCampoValor(newVar);
    // Adiciona o ID/nome do exame ao array de destacados
    setExamesDestacados((prev) => [...prev, singleExame.nome]);

    // Remove o destaque após 3 segundos (ajuste conforme necessário)
    setTimeout(() => {
      setExamesDestacados((prev) =>
        prev.filter((nome) => nome !== singleExame.nome)
      );
    }, 50000);

    const verifyValues = newVar.map((v: any) =>
      isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias)
    );
    setValorTotal(verifyValues.reduce((soma, i) => soma + i, 0));

    setSingleExame(null);
    setValor(null);
    setAsoCheck({
      admissional: false,
      demissional: false,
      periodico: false,
      mudancaDeRiscos: false,
      retornoAoTrabalho: false,
      monitoramento: false
    });
  }

  function closeDialogToxico() {
    setDialogToxico(false);
  }

  function saveNewValorToxico() {
    setNovoValorToxico([...campoValorToxico]);
    setDialogToxico(false);
  }

  function deleteExameToxico(nome: string) {
    const newList = campoValorToxico.filter(
      (exame: any) => exame.nome !== nome
    );
    const verifyValues = newList.map((v: any) =>
      isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias)
    );
    const sub = verifyValues.reduce((soma: number, i: number) => soma + i, 0);

    setValorTotalToxico(sub);
    setCampoValorToxico(newList);
  }

  function valueExamesToxico() {
    if (!singleExameToxico) {
      alert('Selecione um exame');
      return;
    }

    const newVar = [...campoValorToxico];
    const data: any = {
      id_exame: singleExameToxico.id_exame_tox,
      nome: singleExameToxico.nome,
      dias: valorToxico === null ? '0' : valorToxico.toString(),
      // Inicializa todos os campos de ASO como vazios
      admissional: '',
      demissional: '',
      periodico: '',
      mudanca_de_riscos: '',
      retorno_ao_trabalho: '',
      monitoramento: ''
    };

    // Preenche apenas os campos de ASO que foram marcados
    if (asoCheck.admissional) data.admissional = 'admissional';
    if (asoCheck.demissional) data.demissional = 'demissional';
    if (asoCheck.periodico) data.periodico = 'periodico';
    if (asoCheck.mudancaDeRiscos) data.mudanca_de_riscos = 'mudanca_de_riscos';
    if (asoCheck.retornoAoTrabalho)
      data.retorno_ao_trabalho = 'retorno_ao_trabalho';
    if (asoCheck.monitoramento) data.monitoramento = 'monitoramento';

    newVar.push(data);
    setCampoValorToxico(newVar);
    // Adiciona o ID/nome do exame ao array de destacados
    setExamesToxicosDestacados((prev) => [...prev, singleExameToxico.nome]);

    // Remove o destaque após 3 segundos
    setTimeout(() => {
      setExamesToxicosDestacados((prev) =>
        prev.filter((nome) => nome !== singleExameToxico.nome)
      );
    }, 50000);

    const verifyValues = newVar.map((v: any) =>
      isNaN(parseFloat(v.dias)) ? 0 : parseFloat(v.dias)
    );
    setValorTotalToxico(verifyValues.reduce((soma, i) => soma + i, 0));

    setSingleExameToxico(null);
    setValorToxico(null);
    setAsoCheck({
      admissional: false,
      demissional: false,
      periodico: false,
      mudancaDeRiscos: false,
      retornoAoTrabalho: false,
      monitoramento: false
    });
  }

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAsoCheck({ ...asoCheck, [event.target.name]: event.target.checked });
  };

  const renderExames = () => (
    <>
      {campoValor.map((valores: any, i) => (
        <Paper
          key={i}
          elevation={examesDestacados.includes(valores.nome) ? 4 : 2}
          className={
            examesDestacados.includes(valores.nome) ? classes.highlight : ''
          }
          style={{
            padding: '12px',
            marginBottom: '12px',
            borderLeft: examesDestacados.includes(valores.nome)
              ? '4px solid #0D9C5B'
              : 'none',
            transition: 'all 0.3s ease'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              variant="body2"
              style={{ color: '#666', fontSize: '0.8rem' }}
            >
              ID: {valores.id_exame}
            </Typography>
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              {valores.nome}
            </Typography>

            <IconButton
              onClick={() => deleteExame(valores.nome)}
              size="small"
              style={{ color: '#f44336' }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>

          <div
            style={{
              display: 'flex',
              gap: '8px',
              marginTop: '8px',
              flexWrap: 'wrap'
            }}
          >
            {valores.periodico && valores.dias && valores.dias !== '0' && (
              <Chip
                label={`${valores.dias} Dias`}
                size="small"
                style={{
                  backgroundColor: '#e3f2fd',
                  color: '#1976d2',
                  fontWeight: 500
                }}
              />
            )}

            {Object.entries(valores)
              .filter(
                ([key, value]) =>
                  [
                    'admissional',
                    'demissional',
                    'periodico',
                    'mudancaDeRiscos',
                    'mudanca_de_riscos', // Adicionar ambas as formas
                    'retornoAoTrabalho',
                    'retorno_ao_trabalho', // Adicionar ambas as formas
                    'monitoramento'
                  ].includes(key) && value
              )
              .map(([key], idx) => (
                <Chip
                  key={idx}
                  label={
                    key === 'mudancaDeRiscos'
                      ? 'mudança de riscos'
                      : key === 'mudanca_de_riscos'
                      ? 'mudança de riscos'
                      : key === 'retornoAoTrabalho'
                      ? 'retorno ao trabalho'
                      : key === 'retorno_ao_trabalho'
                      ? 'retorno ao trabalho'
                      : key.replace(/([A-Z])/g, ' $1').toLowerCase()
                  }
                  size="small"
                  style={{
                    backgroundColor: '#e8f5e9',
                    color: '#2e7d32',
                    fontWeight: 500
                  }}
                />
              ))}
          </div>
        </Paper>
      ))}
    </>
  );

  const renderExamesToxicos = () => (
    <>
      {campoValorToxico.map((valores: any, i) => (
        <Paper
          key={i}
          elevation={examesToxicosDestacados.includes(valores.nome) ? 4 : 2}
          className={
            examesToxicosDestacados.includes(valores.nome)
              ? classes.highlight
              : ''
          }
          style={{
            padding: '12px',
            marginBottom: '12px',
            borderLeft: examesToxicosDestacados.includes(valores.nome)
              ? '4px solid #0D9C5B'
              : 'none',
            transition: 'all 0.3s ease'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography
              variant="body2"
              style={{ color: '#666', fontSize: '0.8rem' }}
            >
              ID: {valores.id_exame}
            </Typography>
            <Typography variant="body1" style={{ fontWeight: 500 }}>
              {valores.nome}
            </Typography>

            <IconButton
              onClick={() => deleteExameToxico(valores.nome)}
              size="small"
              style={{ color: '#f44336' }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>

          <div
            style={{
              display: 'flex',
              gap: '8px',
              marginTop: '8px',
              flexWrap: 'wrap'
            }}
          >
            {valores.periodico && valores.dias && valores.dias !== '0' && (
              <Chip
                label={`${valores.dias} Dias`}
                size="small"
                style={{
                  backgroundColor: '#e3f2fd',
                  color: '#1976d2',
                  fontWeight: 500
                }}
              />
            )}

            {Object.entries(valores)
              .filter(
                ([key, value]) =>
                  [
                    'admissional',
                    'demissional',
                    'periodico',
                    'mudancaDeRiscos',
                    'mudanca_de_riscos', // Adicionar ambas as formas
                    'retornoAoTrabalho',
                    'retorno_ao_trabalho', // Adicionar ambas as formas
                    'monitoramento'
                  ].includes(key) && value
              )
              .map(([key], idx) => (
                <Chip
                  key={idx}
                  label={
                    key === 'mudancaDeRiscos'
                      ? 'mudança de riscos'
                      : key === 'mudanca_de_riscos'
                      ? 'mudança de riscos'
                      : key === 'retornoAoTrabalho'
                      ? 'retorno ao trabalho'
                      : key === 'retorno_ao_trabalho'
                      ? 'retorno ao trabalho'
                      : key.replace(/([A-Z])/g, ' $1').toLowerCase()
                  }
                  size="small"
                  style={{
                    backgroundColor: '#e8f5e9',
                    color: '#2e7d32',
                    fontWeight: 500
                  }}
                />
              ))}
          </div>
        </Paper>
      ))}
    </>
  );

  if (loading.inicial) {
    return (
      <Container maxWidth="lg" className={classes.root}>
        <Paper className={classes.loadingPaper}>
          <CircularProgress />
          <Typography variant="body1" style={{ marginTop: theme.spacing(2) }}>
            Carregando dados do GHE...
          </Typography>
        </Paper>
      </Container>
    );
  }

  return (
    <Container
      maxWidth="lg"
      style={{
        padding: '24px 0',
        backgroundColor: '#f9f9f9',
        minHeight: '100vh'
      }}
    >
      <Paper
        elevation={3}
        style={{
          padding: '32px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
        }}
      >
        <Typography
          variant="h4"
          align="center"
          style={{
            marginBottom: '32px',
            fontWeight: 600,
            color: '#2c3e50',
            position: 'relative',
            paddingBottom: '16px'
          }}
        >
          Editar GHE
          <div
            style={{
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: '#0D9C5B',
              borderRadius: '2px'
            }}
          />
        </Typography>

        {/* Seção Informações do GHE */}
        <div
          style={{
            marginBottom: '32px',
            padding: '16px',
            borderLeft: '4px solid #0D9C5B',
            backgroundColor: '#f0f7f4'
          }}
        >
          <Typography
            variant="h6"
            style={{
              marginBottom: '16px',
              fontWeight: 600,
              color: '#2c3e50',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <InfoIcon color="primary" />
            Informações do GHE
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Locais/Obras Cadastrados"
                disabled
                value={codGhe}
                onChange={(e) => setCodGhe(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#f5f5f5' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                disabled
                fullWidth
                variant="outlined"
                label="Código GHE"
                value={codGhe}
                onChange={(e) => setCodGhe(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#f5f5f5' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Nome GHE"
                value={nomeGhe}
                onChange={(e) => setNomeGhe(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                variant="outlined"
                label="Médico responsável"
                value={nomeMedico}
                onChange={(e) => setNomeMedico(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                variant="outlined"
                label="CRM"
                value={crm}
                onChange={(e) => setCrm(e.target.value)}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={2}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select
                  label="Estado"
                  value={estadoCrm}
                  onChange={(e: any) => setEstadoCrm(e.target.value)}
                  style={{ borderRadius: '8px', backgroundColor: '#fff' }}
                >
                  {estados.map((estado, index) => (
                    <MenuItem key={index} value={estado.estado}>
                      {estado.estado}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                variant="outlined"
                multiline
                label="Observação ASO"
                value={obsASO}
                onChange={(e) => setObsASO(e.target.value)}
                minRows={4}
                InputProps={{
                  style: { borderRadius: '8px', backgroundColor: '#fff' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel>Plano</InputLabel>
                <Select
                  label="Plano"
                  value={plano}
                  onChange={(e: any) => setPlano(e.target.value)}
                  style={{ borderRadius: '8px', backgroundColor: '#fff' }}
                >
                  {planos.map((plano, index) => (
                    <MenuItem key={index} value={plano.value}>
                      {plano.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </div>

        {/* Seção Exames e Riscos */}
        <div
          style={{
            marginBottom: '32px',
            padding: '16px',
            borderLeft: '4px solid #2196F3',
            backgroundColor: '#f0f7ff'
          }}
        >
          <Typography
            variant="h6"
            style={{
              marginBottom: '16px',
              fontWeight: 600,
              color: '#2c3e50',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <InfoIcon color="primary" />
            Exames e Riscos
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ButtonAdd
                fullWidth
                variant="contained"
                startIcon={<Add />}
                onClick={() => setDialog(true)}
                style={{ height: '56px' }}
              >
                Adicionar Exames
              </ButtonAdd>

              <Dialog
                open={dialog}
                onClose={closeDialog}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  style={{
                    backgroundColor: '#f5f5f5',
                    borderBottom: '1px solid #e0e0e0'
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    Adicionar Exames
                  </Typography>
                </DialogTitle>
                <DialogContent style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '20px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '16px'
                      }}
                    >
                      <Autocomplete
                        style={{ flex: 1 }}
                        onKeyDown={(e: any) => {
                          if (e.key === 'Enter') valueExames();
                        }}
                        id="tags-outlined"
                        options={newData}
                        getOptionLabel={(option: IExames) =>
                          `${option.id_exames} - ${option.nome}`
                        }
                        onChange={(e, newValue: any) =>
                          setSingleExame(newValue)
                        }
                        value={singleExame}
                        getOptionDisabled={(option) => {
                          const valueDisbled = campoValor.map(
                            (exame: any) => exame
                          );
                          return !!valueDisbled.find(
                            (element) => element.nome === option.nome
                          );
                        }}
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Selecione o exame"
                            placeholder="Digite para buscar..."
                            size="small"
                          />
                        )}
                      />

                      <TextField
                        onKeyDown={(e: any) => {
                          if (e.key === 'Enter') valueExames();
                        }}
                        type="number"
                        label="Dias"
                        variant="outlined"
                        value={valor || ''}
                        onChange={(e: any) => setValor(e.target.value)}
                        disabled={!asoCheck.periodico}
                        style={{ width: '120px' }}
                        size="small"
                      />

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={valueExames}
                        startIcon={<Add />}
                        style={{ height: '40px' }}
                      >
                        Adicionar
                      </Button>
                    </div>

                    <Paper
                      elevation={0}
                      style={{
                        padding: '16px',
                        marginBottom: '16px',
                        backgroundColor: '#fafafa'
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          marginBottom: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Tipos de ASO
                      </Typography>

                      <FormGroup row style={{ gap: '16px' }}>
                        {Object.entries(asoCheck).map(([key, value]) => (
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                checked={value}
                                onChange={handleCheck}
                                name={key}
                                color="primary"
                              />
                            }
                            label={
                              <Typography
                                style={{ textTransform: 'capitalize' }}
                              >
                                {key.replace(/([A-Z])/g, ' $1').trim()}
                              </Typography>
                            }
                          />
                        ))}
                      </FormGroup>
                    </Paper>
                  </div>

                  {renderExames()}

                  {campoValor.length > 0 && (
                    <Paper
                      elevation={0}
                      style={{
                        padding: '16px',
                        backgroundColor: '#f5f5f5',
                        marginTop: '16px'
                      }}
                    >
                      <Typography
                        variant="body1"
                        style={{ textAlign: 'center' }}
                      >
                        <strong>Total de exames:</strong> {campoValor.length} |
                        <strong> Total de dias:</strong> {valorTotal}
                      </Typography>
                    </Paper>
                  )}
                </DialogContent>

                <DialogActions
                  style={{
                    padding: '16px 24px',
                    borderTop: '1px solid #e0e0e0'
                  }}
                >
                  <Button onClick={closeDialog} style={{ marginRight: '8px' }}>
                    Cancelar
                  </Button>
                  <Button
                    onClick={saveNewValor}
                    variant="contained"
                    color="primary"
                    disabled={campoValor.length === 0}
                  >
                    Salvar
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>

            <Grid item xs={12} md={6}>
              <ButtonAdd
                fullWidth
                variant="contained"
                startIcon={<Add />}
                onClick={() => setDialogToxico(true)}
                style={{ height: '56px' }}
              >
                Adicionar Exames Toxicológicos
              </ButtonAdd>

              <Dialog
                open={dialogToxico}
                onClose={closeDialogToxico}
                maxWidth="md"
                fullWidth
              >
                <DialogTitle
                  style={{
                    backgroundColor: '#f5f5f5',
                    borderBottom: '1px solid #e0e0e0'
                  }}
                >
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    Adicionar Exames Toxicológicos
                  </Typography>
                </DialogTitle>

                <DialogContent style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '20px' }}>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        marginBottom: '16px'
                      }}
                    >
                      <Autocomplete
                        style={{ flex: 1 }}
                        options={newDataToxico}
                        getOptionLabel={(option: IExamesToxico) =>
                          `${option.id_exame_tox} - ${option.nome}`
                        }
                        onChange={(event, newValue: IExamesToxico | null) => {
                          setSingleExameToxico(newValue);
                        }}
                        value={singleExameToxico}
                        getOptionDisabled={(option) => {
                          const valueDisabled = campoValorToxico.map(
                            (exame: any) => exame
                          );
                          return !!valueDisabled.find(
                            (element) => element.nome === option.nome
                          );
                        }}
                        filterSelectedOptions
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Selecione o exame toxicológico"
                            placeholder="Digite para buscar..."
                            size="small"
                          />
                        )}
                      />

                      <TextField
                        type="number"
                        label="Dias"
                        variant="outlined"
                        value={valorToxico || ''}
                        onChange={(e) => setValorToxico(Number(e.target.value))}
                        disabled={!asoCheck.periodico}
                        style={{ width: '120px' }}
                        size="small"
                      />

                      <Button
                        variant="contained"
                        color="primary"
                        onClick={valueExamesToxico}
                        startIcon={<Add />}
                        style={{ height: '40px' }}
                      >
                        Adicionar
                      </Button>
                    </div>

                    <Paper
                      elevation={0}
                      style={{
                        padding: '16px',
                        marginBottom: '16px',
                        backgroundColor: '#fafafa'
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        style={{
                          marginBottom: '12px',
                          fontWeight: 'bold'
                        }}
                      >
                        Tipos de ASO
                      </Typography>

                      <FormGroup row style={{ gap: '16px' }}>
                        {Object.entries(asoCheck).map(([key, value]) => (
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                checked={value}
                                onChange={handleCheck}
                                name={key}
                                color="primary"
                              />
                            }
                            label={
                              <Typography
                                style={{ textTransform: 'capitalize' }}
                              >
                                {key.replace(/([A-Z])/g, ' $1').trim()}
                              </Typography>
                            }
                          />
                        ))}
                      </FormGroup>
                    </Paper>
                  </div>

                  {renderExamesToxicos()}

                  {campoValorToxico.length > 0 && (
                    <Paper
                      elevation={0}
                      style={{
                        padding: '16px',
                        backgroundColor: '#f5f5f5'
                      }}
                    >
                      <Typography
                        variant="body1"
                        style={{ textAlign: 'center' }}
                      >
                        <strong>Total de exames:</strong>{' '}
                        {campoValorToxico.length} |
                        <strong> Total de dias:</strong> {valorTotalToxico}
                      </Typography>
                    </Paper>
                  )}
                </DialogContent>

                <DialogActions
                  style={{
                    padding: '16px 24px',
                    borderTop: '1px solid #e0e0e0'
                  }}
                >
                  <Button
                    onClick={closeDialogToxico}
                    style={{ marginRight: '8px' }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    onClick={saveNewValorToxico}
                    variant="contained"
                    color="primary"
                    disabled={campoValorToxico.length === 0}
                  >
                    Salvar
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>

            <Grid item xs={12}>
              <Autocomplete
                multiple
                options={listRisco}
                getOptionLabel={(option: IRiscos) =>
                  `${option.id_risco} - ${option.nome}`
                }
                onChange={(e, newValue: IRiscos[]) => {
                  // Identifica quais riscos foram adicionados comparando com o estado anterior
                  const addedRisks = newValue.filter(
                    (newRisk) =>
                      !risco.some(
                        (oldRisk) => oldRisk.id_risco === newRisk.id_risco
                      )
                  );

                  if (addedRisks.length > 0) {
                    setRiscosDestacados(addedRisks.map((r) => r.id_risco));

                    // Remove o destaque após 3 segundos
                    setTimeout(() => {
                      setRiscosDestacados((prev) =>
                        prev.filter(
                          (id) => !addedRisks.some((r) => r.id_risco === id)
                        )
                      );
                    }, 30000);
                  }

                  setRisco(newValue);
                }}
                value={risco}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Riscos Ocupacionais"
                    placeholder="Selecione os riscos"
                    fullWidth
                  />
                )}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.id_risco}
                      label={`${option.id_risco} - ${option.nome}`}
                      style={{
                        margin: '4px',
                        backgroundColor: riscosDestacados.includes(
                          option.id_risco
                        )
                          ? '#0D9C5B'
                          : '#e3f2fd',
                        color: riscosDestacados.includes(option.id_risco)
                          ? '#FFF'
                          : '#1976d2',
                        fontWeight: riscosDestacados.includes(option.id_risco)
                          ? 'bold'
                          : 'normal',
                        transition: 'all 0.3s ease'
                      }}
                    />
                  ))
                }
              />
            </Grid>
          </Grid>
        </div>

        {/* Botões de Ação */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '16px',
            marginTop: '32px',
            paddingTop: '16px',
            borderTop: '1px solid #e0e0e0'
          }}
        >
          <Button
            variant="outlined"
            startIcon={<ArrowBackIcon />}
            style={{
              color: '#5f6c7b',
              borderColor: '#e0e0e0',
              padding: '8px 24px',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500
            }}
            component={Link}
            to="/ghe"
          >
            Voltar
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            onClick={() => {
              setLoading((prev) => ({ ...prev, enviando: true }));
              sendGHE();
            }}
            style={{
              backgroundColor: '#0D9C5B',
              color: '#fff',
              padding: '8px 24px',
              borderRadius: '8px',
              textTransform: 'none',
              fontWeight: 500,
              boxShadow: 'none'
            }}
          >
            {loading.enviando ? (
              <>
                <CircularProgress size={24} style={{ marginRight: 8 }} />
                Salvando...
              </>
            ) : (
              'Salvar GHE'
            )}
          </Button>
        </div>
      </Paper>

      <Snackbar
        open={snack}
        autoHideDuration={3000}
        onClose={() => setSnack(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        style={{ marginTop: '64px' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={severity}
          onClose={() => setSnack(false)}
          style={{
            borderRadius: '8px',
            alignItems: 'center',
            fontWeight: 500
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {severity === 'success' ? (
              <CheckCircleIcon style={{ marginRight: '8px' }} />
            ) : (
              <ErrorIcon style={{ marginRight: '8px' }} />
            )}
            {`${cod} - ${message}`}
          </div>
        </MuiAlert>
      </Snackbar>
    </Container>
  );
};
